import Resource from 'api/resource';

class TagResource extends Resource {
  constructor() {
    super('tags');
  }
}

export { TagResource as default };
